import { gql } from 'apollo-boost';

export const deleteInvestmentMutation = gql`
  mutation deleteInvestmentMutation($id: Int!) {
    deleteInvestment(id: $id) {
      success
    }
  }
`;
